import cn from "classnames"
import { useEffect, useRef, useState } from "react"

import styles from "./TabAdrManagement.module.scss"

export const Loading = (props: { isLoading?: boolean }) => {
  const maxCircles = 10
  const interval = useRef(50)
  const { isLoading } = props

  const CIRCLE_SPECS = [
    { size: 11, color: "#f0f0f0" },
    { size: 64, color: "#f0f0f0" },
    { size: 116, color: "#f0f0f0" },
    { size: 176, color: "#f0f0f0" },
    { size: 250, color: "#f0f0f0" },
    { size: 362, color: "#f5f5f5" },
    { size: 476, color: "#f5f5f5" },
    { size: 614, color: "#f5f5f5" },
    { size: 732, color: "#fafafa" },
    { size: 840, color: "#fafafa" },
    { size: 1212, color: "#fafafa" }
  ]

  const [circles, setCircles] = useState(() =>
    Array.from({ length: maxCircles }, (_, i) => ({ id: i, index: i }))
  )
  const [nextId, setNextId] = useState(maxCircles)

  useEffect(() => {
    if (!isLoading) return

    const timer = setInterval(() => {
      const INTERVAL = 800

      if (interval.current < INTERVAL) interval.current = INTERVAL

      setCircles((prev) => {
        const newCircle = { id: nextId, index: 0 }
        const shifted = prev.map((c) => ({ ...c, index: c.index + 1 }))

        setNextId((n) => n + 1)

        return [newCircle, ...shifted.slice(0, maxCircles - 1)]
      })
    }, interval.current)

    return () => clearInterval(timer)
  }, [nextId, isLoading])

  return (
    <div className={styles.sonarContainer}>
      <div className={styles.sonarWrapper}>
        {circles.map((circle) => {
          const specIndex = Math.min(circle.index, CIRCLE_SPECS.length - 1)
          const spec = CIRCLE_SPECS[specIndex]

          return (
            <div
              key={circle.id}
              className={styles.sonarCircle}
              style={{
                width: `${spec.size}px`,
                height: `${spec.size}px`,
                borderColor: spec.color
              }}
            />
          )
        })}
        <div className={styles.sonarGlow} />
        <div
          className={cn(
            styles.sonarSweep,
            isLoading && styles.sonarSweepLoading
          )}
        />
      </div>
    </div>
  )
}
